module.exports = __webpack_public_path__ + "static/media/anc4ru.945c86f7.pdf";